import { render } from "./CarritoView.vue?vue&type=template&id=1a9bb217&scoped=true"
import script from "./CarritoView.vue?vue&type=script&lang=js"
export * from "./CarritoView.vue?vue&type=script&lang=js"

import "./CarritoView.vue?vue&type=style&index=0&id=1a9bb217&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9bb217"]])

export default __exports__